import { TutorialComponent } from 'components/tutorial/TutorialComponent';
import { ReportManagement } from '..';
import { useTutorialReportManagementData } from './useTutorialReportManagementData';
import { reportSteps } from 'components/tutorial/Steps';
import { useTutorialStore } from 'store/tutorialStore';

export const TutorialReportManagement = () => {
  const {
    reports,
    sites,
    providers,
    remittances,
    submissions,
    payors,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchReports,
  } = useTutorialReportManagementData();

  const { isTutorialActive } = useTutorialStore();
  return (
    <>
      {isTutorialActive && (
        <TutorialComponent steps={reportSteps} page="reports" />
      )}
      <ReportManagement
        reports={reports}
        sites={sites}
        remittances={remittances}
        providers={providers}
        submissions={submissions}
        payors={payors}
        isError={isError}
        isLoading={isLoading}
        isFetching={isFetching}
        refetchReports={refetchReports}
        errorMessage={errorMessage}
      />
    </>
  );
};
